/*
  Analytics Helpers
*/

/**
 * Log an event with GTM. 
 * Adds an event to the dataLayer
 * that GTM knows how to log to GA.
 * @param {String} eventName name of event
 * @param {Object} properties Object of associated data
 */
export function gtmEvent(eventName, properties) {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ...properties, event: eventName });
  }
}

export default {
  gtmEvent,
};
